module.exports = __webpack_public_path__ + "static/media/6.d4ba0bb0.png";